export const ROLES = {
    TEACHER: 'teacher',
    STUDENT: {
        TEAM_MEMBER: 'student_team-member',
        TEAM_LEADER: 'student-team-leader',
    }
};

export class User {
    id: number;
    firstName: string;
    lastName: string;
    role: string;

    get isTeacher(): boolean {
        return this.role === ROLES.TEACHER;
    }

    get isStudent(): boolean {
        return !this.isTeacher;
    }
}

export class Student extends User {}





// WEBPACK FOOTER //
// ./src/app/shared/models/users.ts